import { T, useTranslate } from '@tolgee/react';
import { Button, Modal } from 'antd';
import p1 from './assets/p1.png';
import p2 from './assets/p2.png';
import p3 from './assets/p3.png';
import p4 from './assets/p4.png';
import { useChatDiversionDialog } from './useChatDiversionDialog';
import { BULLETIN_URL, LOCAL_BULLETIN_URL } from './constant';
import { ShopTypeEnum } from 'components/AuthShop/components/ShopeeCNSCGuide';

export const ChatDiversionDialog = () => {
  const { t } = useTranslate();
  const { visible, storeType, hide } = useChatDiversionDialog();

  const isLocal = storeType === ShopTypeEnum.Local;

  let content = null;

  if (isLocal) {
    content = (
      <>
        <p>
          <T
            keyName="chat_diversion_hint_p1"
            params={{
              link: (
                <Button
                  className="!p-0"
                  type="link"
                  href={LOCAL_BULLETIN_URL}
                  target="_blank"
                  rel="noreferrer"
                />
              ),
            }}
          />
        </p>
        <p>{t('chat_diversion_hint_p2')}</p>
        <img className="w-full" src={p4} alt="p4" />
      </>
    );
  } else {
    content = (
      <>
        <p>
          <T
            keyName="chat_diversion_hint_p1"
            params={{
              link: (
                <Button
                  className="!p-0"
                  type="link"
                  href={BULLETIN_URL}
                  target="_blank"
                  rel="noreferrer"
                />
              ),
            }}
          />
        </p>
        <img className="w-full" src={p1} alt="p1" />
        <p>{t('chat_diversion_hint_p2')}</p>
        <img className="w-full" src={p2} alt="p2" />
        <img className="w-full" src={p3} alt="p3" />
      </>
    );
  }

  return (
    <Modal
      title={t('关闭聊天分配功能')}
      width={700}
      visible={visible}
      destroyOnClose
      centered
      onCancel={hide}
      footer={
        <Button type="primary" onClick={hide}>
          {t('好的')}
        </Button>
      }
      bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
    >
      {content}
    </Modal>
  );
};
